import { DexFormModel, DexInquiry } from '../types';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';
import { UseFormReturn } from 'react-hook-form';
import { getDexAttentionValue } from './helpers';

export function useGetDexQuerySpecificValues(
    form: UseFormReturn<DexFormModel<DexInquiry>>
): {
    reasonCode: string | undefined;
    attention: string | undefined;
} {
    const { defaultDexFormsImageIndicator } = useEnabledFeatures();
    const { userProfileView, dexRegion } = useBootstrapState();

    const formFieldValues = {
        reasonCode: form.getValues('params.reasonCode'),
        attention: getDexAttentionValue(form, dexRegion, userProfileView),
    };

    if (!defaultDexFormsImageIndicator) {
        delete formFieldValues.reasonCode;
    }

    return formFieldValues;
}
